/** The `nav.*` key that names the page at this path, or null when there isn't one. */
export function navKeyForPath(pathname: string): string | null {
    const [first, second] = pathname.split("/").filter(Boolean);
    if (!first) return "overview";
    switch (first) {
        case "payments":
        case "plans":
        case "tenants":
        case "associates":
        case "owners":
        case "support":
        case "profile":
        case "notifications":
        case "settings":
            return first;
        case "associate":
            return second === "dashboard" ? "myDashboard" : null;
        case "reports":
            return "monthlyReports";
        case "users":
            return "userManagement";
        case "request-logs":
            return "requestLogs";
        default:
            return null;
    }
}
